import { render, staticRenderFns } from "./PowerContent.vue?vue&type=template&id=6de12e4c"
import script from "./PowerContent.vue?vue&type=script&lang=js"
export * from "./PowerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports